import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService, menuList, isMobile } from '../core';
import { SnackbarService } from '../shared';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass']
})
export class HomeComponent implements OnInit {
  company: string;
  menuList: any[] = JSON.parse(JSON.stringify(menuList));
  showPage = false;
  menuListGroup = [];
  isMobile = isMobile()
  isNotProd: boolean = true;
  constructor(
    public authService: AuthService,
    public snackbarService: SnackbarService,
    private router: Router
  ) {
    this.isNotProd = window.location.hostname.includes('-');
    this.authService.user.subscribe(user => {
      this.company = user.entity ? user.entity.company.code.toLowerCase() : undefined;
      if (!user.visibleModules.length || !user.roles.length || !this.company) {
        this.authService.logout();
        this.router.navigate(['/iniciar-sesion']);
        this.snackbarService.show(
          'No tiene acceso a los módulos del sistema o no tiene roles asignados, comuniquese con el administrador del sistema.',
          'warning'
        );
      } else if (user.visibleModules.length === 1) {
        this.router.navigate(['/' + user.visibleModules[0].moduleIdentifier]);
      } else {
        this.showPage = true;
        for (let i = this.menuList.length - 1; i >= 0; i--) {
          const moduleFound = user.visibleModules.find(
            module => module.moduleIdentifier === this.menuList[i].link.substr(1)
          );
          if (moduleFound) {
            this.menuList[i].name = moduleFound.moduleName;
            this.menuList[i].description = moduleFound.moduleDescription;
            this.menuList[i].active = moduleFound.active;
          } else {
            this.menuList.splice(i, 1);
          }
        }
      }
    });
    let num = 0;
    this.menuList.forEach((item, i)=> {
      
      if (!(i%3)) {
        num = i
        this.menuListGroup[num] = []
      }
      this.menuListGroup[num].push(item);
    })
    this.menuListGroup = this.menuListGroup.filter(i => i && i.length);
  }

  ngOnInit() {}
}
